import React from 'react'
import BannerCapital from '@/assets/images/product/banner-capital.png'

const Banner02 = () => {
  return (
    <img src={BannerCapital} width='100%' alt=""/>
  )
}

export default Banner02